// Which product photo a variant shows.
// A variant stores imageKey:
//   "existing:<filename>"  a photo already saved for the product
//   "new:<fileKey>"        a photo picked in this form, not uploaded yet
//   ""                      no photo (website shows the product photos)
// On submit it becomes imageRef ("existing:<filename>" / "new:<index in images[]>").

export const fileKey = (file) => `${file.name}|${file.size}|${file.lastModified}`;

export const imageKeyOf = (variant) => {
  if (variant?.imageKey !== undefined) return variant.imageKey || "";
  const saved = variant?.images?.[0]?.image;
  return saved ? `existing:${saved}` : "";
};

/** imageRef to send for a variant, given the new files being uploaded with the form */
export const imageRefFor = (variant, newFiles = []) => {
  const key = imageKeyOf(variant);
  if (!key.startsWith("new:")) return key;
  const idx = newFiles.findIndex((f) => fileKey(f) === key.slice(4));
  return idx === -1 ? "" : `new:${idx}`;
};

/** All photos a variant can use: saved ones + ones added in this form */
export const photoChoices = (allImages = [], newFiles = [], imagePath = "", objectUrlFor) => [
  ...allImages.map((img) => ({ key: `existing:${img.image}`, src: `${imagePath || ""}${img.image}` })),
  ...newFiles.map((file) => ({ key: `new:${fileKey(file)}`, src: objectUrlFor(file), isNew: true })),
];
